
import { ADD_LCD, REMOVE_LCD, ACTIVE_LCD, LOGIN_LOGOUT_USER, LOADER_DISPLAY_HIDE, SET_LANGUAGE, ACTIVE_DEAL_ADVERTISEMENT } from "../actions/actionTypes";
import { getActiveLcdData, getOnlyActiveLcdData, getSelectedLanguageOptions, getToken } from "../common/getLocalStorageData";
import { IReducerStateData, ILcdData, IReduxStateData } from "../interfaces/redux";
import EncryptData from "../common/encryption";

const activeLcdData = getActiveLcdData();

const isLogin = getToken();

const initialState: IReduxStateData = {
    lcdData: activeLcdData.data ? activeLcdData.data : [],
    activeLcdIndex: activeLcdData.index !== -1 ? activeLcdData.index : -1,
    activeLcdAlphaIdentifier: activeLcdData.lcd !== '' ? activeLcdData.lcd : '',
    isUserLogin: isLogin ? true : false,
    isFullScreenLoaderDisplay: false,
    activeDealAdvertisement: [],
    previousFetchAdvertisementDeal: '',
    selectedLang: getSelectedLanguageOptions()
};

function rootReducer(state: IReduxStateData = initialState, action: { type: string; payload: { content: IReducerStateData }; }) {
    let lcdDataLocal = state.lcdData;
    let activeLcdLocal = state.activeLcdIndex;
    if (action.type === ACTIVE_DEAL_ADVERTISEMENT) {
        if (Array.isArray(action.payload.content)) {
            const activeDeal = getOnlyActiveLcdData();
            return Object.assign({}, state, { previousFetchAdvertisementDeal: activeDeal?.data?.deal_uuid || "", activeDealAdvertisement: action.payload.content });
        }
    }
    if (action.type === ADD_LCD) {
        if (Array.isArray(action.payload.content))
            return Object.assign({}, state, { lcdData: action.payload.content });
    }
    if (action.type === REMOVE_LCD) {
        if (action.payload.content.isRemoveAllData) {
            lcdDataLocal = [];
            activeLcdLocal = -1;
        }

        return Object.assign({}, state, {
            lcdData: lcdDataLocal,
            activeLcdIndex: activeLcdLocal
        });
    }
    if (action.type === ACTIVE_LCD) {
        console.log("Active LCD >>", state)
        const indexOfItem = state.lcdData.findIndex((item: ILcdData) => {
            return item.alphacode_identifier === action.payload.content.activeLcdIdentifier;
        });
        if (indexOfItem !== -1) {
            localStorage.setItem('alphaIdentifier', JSON.stringify(EncryptData(action.payload.content.activeLcdIdentifier!)))
            return Object.assign({}, state, { activeLcdIndex: indexOfItem, activeLcdAlphaIdentifier: action.payload.content.activeLcdIdentifier })
        }
    }
    if (action.type === LOGIN_LOGOUT_USER) {
        return Object.assign({}, state, {
            isUserLogin: action.payload.content.isUserLogin,
            lcdData: activeLcdData.data ? activeLcdData.data : [],
            activeLcdIndex: activeLcdData.index !== -1 ? activeLcdData.index : -1,
            activeLcdAlphaIdentifier: activeLcdData.lcd !== '' ? activeLcdData.lcd : '',
        });
    }
    if (action.type === LOADER_DISPLAY_HIDE) {
        return Object.assign({}, state, {
            isFullScreenLoaderDisplay: action.payload.content.isFullScreenLoaderDisplay
        });
    }
    if (action.type === SET_LANGUAGE) {
        if (action.payload?.content?.selectedLang) {
            localStorage.setItem("selectedLanguage", EncryptData(action.payload.content.selectedLang));
        }
        return Object.assign({}, state, {
            selectedLang: action.payload.content.selectedLang
        });
    }
    return state;
}
export default rootReducer;
